import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { environment } from 'src/environments/environment';
import { MentorMappingListingModel, MentorMappingGridParams } from 'common/models/page-models/mentor-mapping/mentor-mapping-grid-model';
import { MentorMappingModel } from 'common/models/page-models/mentor-mapping/mentor-mapping-model';



@Injectable({
    providedIn: 'root'
})
export class MentorMappingGridDataService extends GridDataService<MentorMappingListingModel, MentorMappingModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getMentorMappingData, http, ss);
    }

    createInstance(): MentorMappingListingModel {
        return new MentorMappingListingModel();
    }

    override getDeleteUrl(): string {
        return environment.apiUrl + API_URL.deleteMentorMapping;
    }

    override getGridParams(param): GridPostParams {
        return new MentorMappingGridParams();
    }

    override getDeletePayload(data) {
        let payload = {
            multi_check: [data.id]
        }
        return payload;
    }

    override getExcelUploadUrl(){
        return environment.apiUrl +API_URL.downloadSampleMentorMapping;
    }

    override getModifiedGridModel(apiRes, gridModel) {
        // console.log(apiRes.details[0]['isEmailSendFlag'],'-=====');
        
        gridModel['isEmailSendFlag']=apiRes.details[0]['isEmailSendFlag'];
        return gridModel;
      }
}
